import type { AdminAttributeUpdateRequest, AdminProductUpdateResponse, AdminStatusChangeRequest } from "@shared/types/admin-product-update";
import { axios } from ".";

const ADMIN_PRODUCT_UPDATES_URL = "/api/v1/products/admin/product-updates";

const isAdminProductUpdateResponse = (value: unknown): value is AdminProductUpdateResponse =>
  typeof value === "object" &&
  value !== null &&
  Array.isArray(Reflect.get(value, "results")) &&
  Array.isArray(Reflect.get(value, "failures"));

// Opted out of the auth-error→logout pipeline, like the admin catalogue, so a 403 surfaces to the caller.
const postAdminProductUpdate = async (path: string, accessToken: string, body: unknown): Promise<AdminProductUpdateResponse> => {
  const response = await axios.post<{ data: unknown }>(`${ADMIN_PRODUCT_UPDATES_URL}/${path}`, body, {
    headers: { "x-access-token": accessToken },
    skipAuthLogout: true,
  });
  const data = response.data.data;
  if (!isAdminProductUpdateResponse(data)) {
    throw new Error("Unexpected response shape from admin product updates endpoint");
  }
  return data;
};

/** Raises a Beanz Manager attribute update: one Salesforce approval request per SKU. */
export const postAdminAttributeUpdate = (accessToken: string, request: AdminAttributeUpdateRequest) =>
  postAdminProductUpdate("attributes", accessToken, request);

/** Raises a Beanz Manager web status change for a single SKU. */
export const postAdminStatusChange = (accessToken: string, request: AdminStatusChangeRequest) =>
  postAdminProductUpdate("status", accessToken, request);
